import { toastAlert } from "$lib/commons-web2/toast-alert"
import { InvalidSessionError } from "@tastyworks/tastyworks-api"
import session from "$lib/tastyworks-rest/session.ts"
import { setPromptBeforeUnload } from "$lib/controller/prompt-before-unload.ts"
import { getGenericAlert } from "@tastyworks/result"

export class AbortSubmissionError extends Error {
  constructor() {
    super("Uncaught AbortSubmissionError thrown outside Form context")
  }
}

export class GlobalErrorHandler {
  isTerminal: boolean = false

  toast() {
    const { title, message } = getGenericAlert()
    toastAlert("error", title, message)
  }

  static redirectToSignup() {
    setPromptBeforeUnload(false)
    session.clear()
    window.location.assign("/signup")
  }

  // Handles errors within SvelteKit's load functions and initial rendering
  static handleLoadError({ error }: { error: unknown }) {
    console.error(error)

    if (error instanceof InvalidSessionError) {
      GlobalErrorHandler.redirectToSignup()
    }
  }

  // Handles all other synchronous and async errors
  handleError(error: unknown) {
    this.isTerminal = true
    console.error(error)

    if (error instanceof InvalidSessionError) {
      GlobalErrorHandler.redirectToSignup()
      return
    }

    this.toast()
  }
}
